// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bj-upload-20210723 .el-upload-list__item-thumbnail .el-image {\n  height: 100%;\n  width: 100%;\n}\n.bj-upload-20210723 .hide-upload .el-upload--picture-card {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
